import type { FunctionComponent } from "react";
import { useAuth, SignInButton, SignUpButton } from "@clerk/react";
import { authStyles, CLERK_ENABLED } from "./authStyles";
import { AccountMenu } from "./AccountMenu";

interface Props {
  readonly chessUsername: string | null;
  readonly platform: string | null;
  readonly onLinkAccount: () => void;
}

/** The top bar's right side: Sign In / Sign Up signed out, the account button signed in. */
const ClerkAuthButtons: FunctionComponent<Props> = (account) => {
  const { isSignedIn, isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div style={authStyles.skeleton} />
      </div>
    );
  }

  if (isSignedIn) return <AccountMenu {...account} />;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      <SignInButton mode="modal">
        <button style={authStyles.signInButton}>Sign In</button>
      </SignInButton>
      {/* Under sm, Sign In alone: the two buttons left the tabs ~70px on a phone (#262), and Clerk's sign-in
          screen links to sign-up. */}
      <SignUpButton mode="modal">
        <button className="max-sm:hidden" style={authStyles.signUpButton}>Sign Up</button>
      </SignUpButton>
    </div>
  );
};

export const AuthButtons: FunctionComponent<Props> = (props) => {
  if (!CLERK_ENABLED) return null;
  return <ClerkAuthButtons {...props} />;
};
